export default __webpack_public_path__ + "src/assets/downloads/Register of Tailings Storage Facilities and Dams.xlsm";